import { get, post } from 'utils/rxfetch'

export default () => ({
  getIncidentsActivityLog(
    companyId = '',
    eventFilter = 2,
    targetsFilter = 5,
    page = 1,
    pageSize = 20
  ) {
    // the defaults values here are needed to filter the activity log for certain types of activities
    // limit to the latest 20 activities
    return get(
      `/members-api/auditevents?eventType=${eventFilter}&target=${targetsFilter}&page=${page}&pageSize=${pageSize}&companyFilter=${companyId}`
    )
  },
  getReadinessPercent(companyId = '') {
    return get(`/members-api/companies/readinesslevel/calculation?companyFilter=${companyId}`)
  },
  getRecommendation(companyId = '') {
    return get(`/members-api/companies/readinesslevel/recommendation?companyFilter=${companyId}`)
  },
  getFreeTrialStatus(companyFilter = '') {
    return get(`/members-api/companies/license-upgrade-request?companyFilter=${companyFilter}`)
  },
  setFreeTrialStatus(companyFilter = '', data) {
    return post(
      `/members-api/companies/license-upgrade-request?companyFilter=${companyFilter}`,
      data
    )
  },
})
